import React from 'react'
import LowRatesAndFees from "website/home/low-rates-and-fees.svg"
import FullyFeatured from "website/home/fully-featured-loans.svg"
import TailoredService from "website/home/tailored-personal-service.svg"
import DigitalHomeLoan from "website/home/digital-home-loan-exp.svg"

const WhyYard = () => (
  <div className="why-yard-container">
    <h3 className="text-center">Why Yard</h3>
    <div className="why-yard-contents-wrapper">
      <div className="why-yard-contents-container">
        <LowRatesAndFees />
        <div className="why-yard-texts-container">
          <h4>Low rates and fees</h4>
          <p className="why-yard-text">Market leading Principal & Interest and Interest Only rates for owner-occupiers and investors</p>
        </div>
      </div>
      <div className="why-yard-contents-container">
        <FullyFeatured />
        <div className="why-yard-texts-container">
          <h4>Fully-featured loans</h4>
          <p className="why-yard-text">Our loans have all the bells and whistles - online access with redraw, early repayment and offset functionality</p>
        </div>
      </div>
    </div>

    <div className="why-yard-contents-wrapper">
      <div className="why-yard-contents-container">
        <TailoredService />
        <div className="why-yard-texts-container">
          <h4>Tailored personal service</h4>
          <p className="why-yard-text">At Yard you get your personal consultant who works with you throughout your home buying or refinancing journey</p>
        </div>
      </div>
      <div className="why-yard-contents-container">
        <DigitalHomeLoan />
        <div className="why-yard-texts-container">
          <h4>A digital home loan experience</h4>
          <p className="why-yard-text">Simple smarter journey to financing, online application - complete anytime, from any device</p>
        </div>
      </div>
    </div>
    <div className='why-yard-btn-container'>
      <a className="btn btn-xl btn-green mr-sm-2 apply-now-btn" id="apply-now-btn" href='/onboarding_funnel/new'>
        Apply now
      </a>
      <a className="btn btn-xl btn-line-green ml-sm-2 view-rates-btn" id="view-rates-btn" href='/pages/our-rates'>
        View rates
      </a>
    </div>
  </div>
);

export default WhyYard
